import { render, staticRenderFns } from "./ro_header.vue?vue&type=template&id=5e735074&"
import script from "./ro_header.vue?vue&type=script&lang=js&"
export * from "./ro_header.vue?vue&type=script&lang=js&"
import style0 from "./ro_header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\vue_project\\odoo14_chaxin_qzkj_vue\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports